import SemVer from 'semver';
import { fetchPackageDetails } from './package-details-reader.js';
import type { PackageJson, PackageDetails } from './types.js';

export async function versionNotifier(
  packageJson: PackageJson
): Promise<PackageDetails | undefined> {
  const packageDetails = await fetchPackageDetails(packageJson);

  return {
    currentVersion: packageJson.version,
    latestVersion: packageDetails.latestVersion,
    deprecated: packageDetails.deprecated,
    newestVersion: SemVer.eq(packageDetails.latestVersion, packageJson.version),
  };
}
